import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, formatoMonto, seleccionarCampo, validaMonto, validarCantidad, validarCantidaddos } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";

const ActualizarVacios = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  const cmbCedula = ["J", "V", "G", "P"];

  const txtCliente = useRef();
  const txtDespachado = useRef();
  const txtDevuelto = useRef([]);
  const txtCantidad = useRef([]);
  const txtPendientes = useRef();
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNotaEntrega = useRef();
  const txtTotalVacios = useRef();
  const [nota, setNota] = useState(null);
  const [esCredit, setEsCredit] = useState(null);
  const [valnota, setValnota] = useState(0);
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let nomtabla;
  if (esCredit !== 0) {
    nomtabla = [
      { label: "TIPO DE VACIO", textAlign: "center", width: "250px" },
      { label: "VACIOS PRESTADOS", textAlign: "center", width: "80px" },
      { label: "VACIOS RETORNADO", textAlign: "center", width: "80px" },
      { label: "VACIOS PENDIENTES", textAlign: "center", width: "80px" },
      { label: "RETORNAR", textAlign: "center", width: "80px" },
    ];
  } else {
    nomtabla = [
      { label: "TIPO DE VACIO", textAlign: "center", width: "250px" },
      { label: "VACIOS DESPACHADO", textAlign: "center", width: "80px" },
      { label: "VACIOS RETORNADO", textAlign: "center", width: "80px" },
      { label: "VACIOS PENDIENTES", textAlign: "center", width: "80px" },
      { label: "RETORNAR", textAlign: "center", width: "80px" },
    ];
  }
  const headCells = nomtabla;
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setNota(null);
    setEsCredit(null);
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };



  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {
      if (records.length > 0) {
        sigue = true;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Error de Transacción !",
          icono: "informacion",
        });
        sigue = false;
      }

      if (sigue) {
        let notaentre = [];
        let opeinv = [];
        let notaentredet = [];
        let opeinvdet = [];


        for (let i = 0; i < records.length; i++) {
          notaentredet.push({
            idclasevacio: records[i].idclasevacio,
            idproducto: records[i].idproducto,
            despachado: records[i].despachado,
            devuelto: records[i].devuelto,
            pendiente: records[i].pendiente
          });

          if (records[i].cantidad > 0) {
            if (esCredit !== 0) {
              opeinvdet.push({
                idclasevacio: records[i].idclasevacio,
                cantidad: records[i].cantidad,
                tipomovimiento: "DESPACHO",
                fechatipomovimiento: moment(fechasistema).format('DD-MM-YYYY'),
                numfactura: records[i].numnotavacio,
                idalmacen: records[i].idalmacen
              });
            } else {
              opeinvdet.push({
                idclasevacio: records[i].idclasevacio,
                cantidad: records[i].cantidad,
                tipomovimiento: "RECEPCION",
                fechatipomovimiento: moment(fechasistema).format('DD-MM-YYYY'),
                numfactura: records[i].numnotavacio,
                idalmacen: records[i].idalmacen
              });
            }
          }

        }

        notaentre.push({
          idnotavacio: props.data[0].idnotavacio,
          numnotavacio: props.data[0].numnotavacio,
          descripcion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
          tipo: props.data[0].tipo,
          totaldespachado: txtDespachado.current.value,
          totaldevuelto: txtDevuelto.current.value,
          totalpendiente: txtPendientes.current.value,
          idcliente: props.data[0].idcliente,
          idvendedor: props.data[0].idvendedor,
          fecha: moment(fechasistema).format('DD-MM-YYYY'),
          status: txtDevuelto.current.value === txtDespachado.current.value ? 1 : 0,
          idalmacen: props.data[0].idalmacen,
          notaentredet: notaentredet
        });

        if (esCredit !== 0) {
          opeinv.push({
            idtipopeinv: 2,
            idoperacioninventario: 0,
            tipooperacion: "SALIDA",
            idalmacenorigen: props.data[0].idalmacen,
            idalmacendestino: "",
            fecha: moment(fechasistema).format('DD-MM-YYYY'),
            observacion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
            numnotavacio: props.data[0].numnotavacio.trim(),
            opeinvdet: opeinvdet
          });
        } else {
          opeinv.push({
            idtipopeinv: 1,
            idoperacioninventario: 0,
            tipooperacion: "INGRESO",
            idalmacenorigen: props.data[0].idalmacen,
            idalmacendestino: "",
            fecha: moment(fechasistema).format('DD-MM-YYYY'),
            observacion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
            numnotavacio: props.data[0].numnotavacio.trim(),
            opeinvdet: opeinvdet
          });
        }

        setBody({
          notaentre: notaentre,
          opeinv: opeinv
        });

        let msg = "";
        if (props.opera === 2) {
          msg = "Esta Seguro de Procesar este Registro.";
        } else if (props.opera === 4) {
          msg = "Esta Seguro de Eliminar este Registro.";
        }

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventariovacio/actualizarnotavacio/${props.opera === 4 ? 3 : 2}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.opera === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "N° Control de Vacio Actualizado Correctamente",
              icono: "exito",
            });
          } else if (props.opera === 4) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Control de Vacio Eliminado Correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };

  const actualizarVacio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "cantidad") {
        let cantidades = validarCantidaddos({
          index: index,
          event: event,
          vacios: records,
        });
        if (event.which === 13) {
          if (index < cantidades.data.length) {
            setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
          }
        }

        let data = [...records];

        let cantvacios = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let devu = parseFloat(data[index].devueltoreal);
        let pendi = data[index].pendientereal;
        let valto = devu + cantvacios;

        if (parseFloat(valto) > parseFloat(data[index].despachado)) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ La Cantidad de Vacios no Debe ser Mayor a la Cantidad Despachado !",
            icono: "informacion",
          });
          data[index].devuelto = data[index].devueltoreal;
          data[index].pendiente = data[index].pendientereal;
          data[index].cantidad = 0.00;
        } else {
          data[index].devuelto = cantvacios === 0 ? data[index].devueltoreal : devu + cantvacios;
          data[index].pendiente = cantvacios === 0 ? data[index].pendientereal : pendi - cantvacios;
          data[index].cantidad = cantvacios;
        }


        let totalv = 0.00;
        let todevu = 0.00;
        let todespa = 0.00;
        let topendi = 0.00;

        for (let c = 0; c < data.length; c++) {

          totalv = parseFloat(totalv) + parseFloat(data[c].devuelto);
          todevu = parseFloat(todevu) + parseFloat(data[c].devuelto);
          todespa = parseFloat(todespa) + parseFloat(data[c].despachado);
          topendi = parseFloat(topendi) + parseFloat(data[c].pendiente);

        }

        txtDespachado.current.value = todespa;
        txtDevuelto.current.value = todevu;
        txtPendientes.current.value = topendi;

        txtTotalVacios.current.value = formatMoneda(
          totalv
            .toString()
            .replace(",", "")
            .replace(".", ","),
          ",",
          ".",
          2
        );

        setRecords(data);

      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {

          cmbRif.current.value = props.data[0].rifcliente.substring(0, 1);
          txtRif.current.value = props.data[0].rifcliente.substring(1, 12);
          txtCliente.current.value = props.data[0].cliente;
          let data = [];
          let totalv = 0.00;

          if (props.data[0].tipo !== 'NC') {
            setEsCredit(0);
          } else {
            setEsCredit(1);
          }

          if (props.data[0].numnotaentrega !== null && props.data[0].numnotaentrega !== 'N/S') {
            setValnota(1);
            setNota(props.data[0].numnotaentrega);
          } else {
            setValnota(0);
            setNota(props.data[0].numnotavacio);
          }

          for (let i = 0; i < props.data.length; i++) {
            data.push({
              clasevacio: props.data[i].clasevacio,
              idproducto: props.data[i].idproducto,
              despachado: props.data[i].despachado,
              devuelto: props.data[i].devuelto,
              idalmacen: props.data[i].idalmacen,
              idcliente: props.data[i].idcliente,
              idnotavacio: props.data[i].idnotavacio,
              idoperacioninventariovacio: props.data[i].idoperacioninventariovacio,
              numnotavacio: props.data[i].numnotavacio,
              pendiente: props.data[i].pendiente,
              tipo: props.data[i].tipo,
              idclasevacio: props.data[i].idclasevacio,
              cantidad: 0,
              despachadoreal: props.data[i].despachado,
              devueltoreal: props.data[i].devuelto,
              pendientereal: props.data[i].pendiente,
            });

            totalv = parseFloat(totalv) + parseFloat(props.data[i].devuelto);

          }
          txtTotalVacios.current.value = formatMoneda(
            totalv
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          setRecords(data);
          if (data.length > 0) {
            setTimeout(() => txtCantidad.current[0].focus(), 300);
          }

        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Gestionar Entrega de Vacios</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12" style={{ margin: 0 }}>
            <div className="col-md-12 row border-azul mx-auto rounded py-1">

              {esCredit !== 0 ? <div className="col-pd-350 px-1">
                <div className="input-group input-group-sm mb-2 px-1">
                  <label
                    className="input-group-text text-primary fw-bold fs-5"
                    id="inputGroup-sizing-sm"
                  >
                    CREDITO DE VACIO
                  </label>
                </div>
              </div> : ''}

              <div className="col-pd-350 ml-auto">
                <div className="input-group input-group-sm mb-2 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    {valnota !== 0 ? "N° NOTA DE ENTREGA:" : "N° NOTA DE VACIO:"}
                  </label>
                  <input
                    disabled={true}
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtNotaEntrega}
                    defaultValue={nota}
                  />
                </div>
              </div>

              <div
                className="col-12 mx-auto mb-1 "
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">

                  <span className="fw-bold mb-1">Datos del Cliente/Proveedor</span>
                  <div className="input-group input-group-sm mb-2 col-3 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled
                      maxLength={12}
                      type="text"
                      className="form-control fs-6 px-1"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-9 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle bg-light text-center p-0">
                            {item.clasevacio}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-right p-0 pl-2 border-warning"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.despachado
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-right p-0 border-success"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.devuelto
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2 border-danger"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.pendiente
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "80px" }}
                          >
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="cantidad"
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              disabled={props.opera === 4 ? true : false}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={actualizarVacio(index)}
                              onBlur={actualizarVacio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-md-4 border-azul px-0 rounded ml-auto border-3">
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL VACIOS ENTREGADOS:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtTotalVacios}
                  />
                  <input type="hidden" ref={txtDespachado} />
                  <input type="hidden" ref={txtDevuelto} />
                  <input type="hidden" ref={txtPendientes} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          ref={btnAcepta}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Procesar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>

      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default ActualizarVacios;



// WEBPACK FOOTER //
// ./src/components/vacios/actualizarVacios.js